import { useRolodexFileLS } from 'features/rolodex'
import { useMemo } from 'react'

export const useHasKestrel3DTiles = (kestrelModelId: string | undefined) => {
  const { fileRefs, isLoading, error } = useRolodexFileLS(
    kestrelModelId
      ? {
          entry_id: kestrelModelId,
          path: '**/tileset.json',
        }
      : undefined
  )

  const tilesFolderInfo = useMemo(() => {
    if (error) {
      return { has3DTiles: false, availableLayers: [] }
    }

    if (!fileRefs || fileRefs.length === 0) {
      return { has3DTiles: false, availableLayers: [] }
    }

    const tilesetPattern = /^3d_tiles\/([^/]+)\/tileset\.json$/
    const availableLayers = fileRefs
      .map((ref) => {
        const match = ref.path.match(tilesetPattern)
        return match ? match[1] : null
      })
      .filter((layer): layer is string => layer !== null)

    const has3DTiles = availableLayers.length > 0

    return { has3DTiles, availableLayers }
  }, [fileRefs, error])

  return { ...tilesFolderInfo, isLoading }
}
